<template>
	<div class="route-info-content">
		<el-dialog
			title="路线客商渠道统计"
			v-if="dialogVisible"
			:visible.sync="dialogVisible"
			:close-on-click-modal="false"
			:close-on-press-escape="false"
			:modal-append-to-body="false"
			width="1000px"
			top="3vh"
			ref="dialog"
		>
            <div class="info">
                <el-checkbox v-model="checked" @change="getList">显示原路线</el-checkbox>
            </div>
			<el-table
				border
				:data="channelList"
				:header-cell-style="{
					background: 'rgba(200, 204, 215,.6)',
					color: '#333333'
				}"
			>
				<el-table-column align="center" label="序号" type="index" width="60">
					<template slot-scope="scope">
						{{ scope.$index + 1 }}
					</template>
				</el-table-column>
				<el-table-column prop="routeName" label="路线" width="160" :show-overflow-tooltip="true">
					<template slot-scope="scope">
						{{ scope.row.routeName }}{{ isOrgroutes[scope.row.isOrgroute] }}
					</template>
				</el-table-column>
				<el-table-column prop="agentName" label="类型" width="60" :show-overflow-tooltip="true">
					<template slot-scope="scope">
						{{ routeTypes[scope.row.routeType] }}
					</template>
				</el-table-column>
				<el-table-column prop="dayAver" label="日均" width="60" :show-overflow-tooltip="true">
				</el-table-column>
				<el-table-column v-for="(item,i) in channelsList" :key="i" :width="item.channelName.length == 2 ? '60' : item.channelName.length*22+''" :label="item.channelName" :show-overflow-tooltip="true">
					<template slot-scope="scope">
						{{ scope.row[item.channelCode] }}
					</template>
				</el-table-column>
			</el-table>
		</el-dialog>
	</div>
</template>
<script>
export default {
	data() {
		return {
			dialogVisible: false,
            checked: false,
			channelList: [],
			channelsList: [],
			// 类型
            routeTypes: {
				0: 'Min',
				1: '单人',
				2: '双人'
            },
			isOrgroutes: {
				0: '',
				1: '（原）'
			}
		};
	},
	methods: {
		init(channelsList) {
			this.dialogVisible = true;
			this.checked = false;
			this.$nextTick(() => {
				for (const item of channelsList) {
					item.channelCode = item.channelCode.toLowerCase();
				}
				this.channelsList = channelsList;
				this.channelList = [];
				this.getList();
			});
		},
		getList() {
			this.$request
				.post("routeMapListChannel", true, {
					orgflag: this.checked ? '1' : '0'
				})
				.then(res => {
					if(res.code == '0') {
						this.channelList = res.data;
					}
				});
		},
		// 关闭
		handleClose() {
			this.dialogVisible = false;
		}
	}
};
</script>
<style lang="scss" scoped>
.route-info-content /deep/ .el-dialog__body {
	padding: 0 5px 20px;
}
.route-info-content /deep/ .el-table .cell,
.route-info-content /deep/ .el-table .el-table__cell,
.route-info-content /deep/ .el-table th.el-table__cell > .cell {
	padding: 1px 5px;
}
.flex-1{
    width: 400px;
    padding: 10px;
    box-sizing: border-box;
}

.agent-info{
	color: #000;
	font-weight: bold;
	margin-bottom: 3px;
}

.info{
	padding: 5px 10px;
	box-sizing: border-box;
}

.mr30 {
	margin-right: 30px;
}
</style>
